module.exports = __webpack_public_path__ + "static/media/featured_img.bb74c367.png";